var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowUpButtonIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1164_1026)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_1164_1026",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 16C8 11.5817 11.5817 8 16 8H34C38.4183 8 42 11.5817 42 16V34C42 38.4183 38.4183 42 34 42H16C11.5817 42 8 38.4183 8 34V16Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8 16C8 11.5817 11.5817 8 16 8H34C38.4183 8 42 11.5817 42 16V34C42 38.4183 38.4183 42 34 42H16C11.5817 42 8 38.4183 8 34V16Z",
    fill: "#0E0F10",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint0_diamond_1164_1026_clip_path)",
    "data-figma-skip-parse": "true",
    mask: "url(#path-1-inside-1_1164_1026)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 0.017 -0.017 0 25 25)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1058.82,
    height: 1058.82,
    fill: "url(#paint0_diamond_1164_1026)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1058.82,
    height: 1058.82,
    transform: "scale(1 -1)",
    fill: "url(#paint0_diamond_1164_1026)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1058.82,
    height: 1058.82,
    transform: "scale(-1 1)",
    fill: "url(#paint0_diamond_1164_1026)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1058.82,
    height: 1058.82,
    transform: "scale(-1)",
    fill: "url(#paint0_diamond_1164_1026)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M16 8V9H34V8V7H16V8ZM42 16H41V34H42H43V16H42ZM34 42V41H16V42V43H34V42ZM8 34H9V16H8H7V34H8ZM16 42V41C12.134 41 9 37.866 9 34H8H7C7 38.9706 11.0294 43 16 43V42ZM42 34H41C41 37.866 37.866 41 34 41V42V43C38.9706 43 43 38.9706 43 34H42ZM34 8V9C37.866 9 41 12.134 41 16H42H43C43 11.0294 38.9706 7 34 7V8ZM16 8V7C11.0294 7 7 11.0294 7 16H8H9C9 12.134 12.134 9 16 9V8Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_DIAMOND\",\"stops\":[{\"color\":{\"r\":1.0,\"g\":0.29411765933036804,\"b\":0.29411765933036804,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":1.0,\"g\":0.47843137383460999,\"b\":0.0,\"a\":0.0},\"position\":1.0}],\"stopsVar\":[{\"color\":{\"r\":1.0,\"g\":0.29411765933036804,\"b\":0.29411765933036804,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":1.0,\"g\":0.47843137383460999,\"b\":0.0,\"a\":0.0},\"position\":1.0}],\"transform\":{\"m00\":2.0818996229250058e-15,\"m01\":-34.0,\"m02\":42.0,\"m10\":34.0,\"m11\":2.0818996229250058e-15,\"m12\":8.0},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}",
    mask: "url(#path-1-inside-1_1164_1026)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4604 24.2729C30.4082 24.3252 30.3461 24.3667 30.2779 24.395C30.2096 24.4233 30.1364 24.4379 30.0624 24.4379C29.9885 24.4379 29.9153 24.4233 29.847 24.395C29.7788 24.3667 29.7167 24.3252 29.6645 24.2729L25.5624 20.1702V31.1875C25.5624 31.3366 25.5032 31.4797 25.3977 31.5852C25.2922 31.6907 25.1491 31.75 24.9999 31.75C24.8508 31.75 24.7077 31.6907 24.6022 31.5852C24.4967 31.4797 24.4374 31.3366 24.4374 31.1875V20.1702L20.3354 24.2729C20.2299 24.3785 20.0867 24.4378 19.9374 24.4378C19.7882 24.4378 19.645 24.3785 19.5395 24.2729C19.4339 24.1674 19.3746 24.0242 19.3746 23.875C19.3746 23.7257 19.4339 23.5825 19.5395 23.477L24.602 18.4145C24.6542 18.3622 24.7163 18.3207 24.7845 18.2924C24.8528 18.2641 24.926 18.2495 24.9999 18.2495C25.0739 18.2495 25.1471 18.2641 25.2154 18.2924C25.2836 18.3207 25.3457 18.3622 25.3979 18.4145L30.4604 23.477C30.5127 23.5292 30.5542 23.5913 30.5825 23.6596C30.6108 23.7278 30.6254 23.801 30.6254 23.875C30.6254 23.9489 30.6108 24.0221 30.5825 24.0904C30.5542 24.1586 30.5127 24.2207 30.4604 24.2729Z",
    fill: "#FEFEFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1164_1026",
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.52549 0 0 0 0 0.231373 0 0 0 0 0.0235294 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1164_1026"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1164_1026",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "paint0_diamond_1164_1026_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 8V9H34V8V7H16V8ZM42 16H41V34H42H43V16H42ZM34 42V41H16V42V43H34V42ZM8 34H9V16H8H7V34H8ZM16 42V41C12.134 41 9 37.866 9 34H8H7C7 38.9706 11.0294 43 16 43V42ZM42 34H41C41 37.866 37.866 41 34 41V42V43C38.9706 43 43 38.9706 43 34H42ZM34 8V9C37.866 9 41 12.134 41 16H42H43C43 11.0294 38.9706 7 34 7V8ZM16 8V7C11.0294 7 7 11.0294 7 16H8H9C9 12.134 12.134 9 16 9V8Z",
    mask: "url(#path-1-inside-1_1164_1026)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_diamond_1164_1026",
    x1: 0,
    y1: 0,
    x2: 500,
    y2: 500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4B4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7A00",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpButtonIcon);
export default __webpack_public_path__ + "static/media/arrow-up-button-icon.a729474cf938ad0b732c606fba375c9c.svg";
export { ForwardRef as ReactComponent };